<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :xs="{ span: 24 }">
      <a-form :form="form">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="SPPD Detail">
              <a-select
                showSearch
                placeholder="Select sppd"
                @change="handleSppd"
                option-filter-prop="children"
                :filter-option="filterOption"
                :loading="sppddtlLoading"
                :disabled="sppddtlLoading"
                class="m-width-full"
                v-decorator="[
                  'id_sppd_dtl',
                  {
                    rules: [{ required: true }],
                  },
                ]"
              >
                <a-select-option
                  v-for="item in sppdDetail"
                  :key="item.id_sppd_dtl"
                  style="width: 100% !important"
                >
                  <!-- <div class="option-between">
                  <div
                    class="option-between__left"
                  > {{ item.item_nm }}
                      <small v-if="!getScreen"> | </small>
                      <small v-if="!getScreen">{{ item.kode_anggaran }}</small>
                  </div>
                  <div class="option-between__right">
                    <small>{{
                      formatRupiah(item.saldo_anggaran)
                        .replace("Rp", "")
                        .replace(",00", "")
                    }}</small>
                  </div>
                  </div>-->

                  <div class="elipsdiv">
                    <div class="elipsdiv-mouseover-label1">
                      {{ item.item_nm }}
                      <small v-if="!getScreen">|</small>
                      <small v-if="!getScreen">{{ item.kode_anggaran }}</small>
                    </div>
                    <div class="elipsdiv-mouseover-label2">
                      <b style="float: right">
                        {{
                          formatCurrency(
                            "IDR",
                            parseFloat(item.saldo_anggaran)
                          ).replace(",00", "")
                        }}
                      </b>
                    </div>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Detail Name">
              <a-input
                v-decorator="['detail_name', { rules: [{ required: true }] }]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Date Usage">
              <a-date-picker
                placeholder="Select Date"
                :format="getDefaultDateFormat"
                v-decorator="[
                  'tanggal_pemakaian',
                  { rules: [{ required: true }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="Credit">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                v-decorator="['kredit', { rules: [{ required: true }] }]"
              />
            </a-form-item>
            <a-row :gutter="12">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Is Commission?">
                  <a-radio-group
                    v-decorator="[
                      'iscommision',
                      { rules: [{ required: false }], initialValue: '0' },
                    ]"
                    :disabled="EnCommission"
                    button-style="solid"
                    @change="handleOptionCommission"
                  >
                    <a-radio-button value="1"> Yes </a-radio-button>
                    <a-radio-button value="0"> No </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                  <a-form-item label="With Note?" :hidden="true">
                  <a-radio-group
                    v-decorator="[
                      'without_note',
                      { rules: [{ required: false }], initialValue: '1' },
                    ]"
                    button-style="solid"
                  >
                    <a-radio-button value="0"> Yes </a-radio-button>
                    <a-radio-button value="1"> No </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Upload Transaction Document">
              <a-upload
                :showUploadList="true"
                :fileList="doctransfiles"
                :beforeUpload="beforedoctransUpload"
                :remove="handledoctransRemove"
                v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
              >
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-divider class="margin-bottom-small">or</a-divider>
      <div>
        <h4>Upload File Excel</h4>
        <p>
          If you don't have the file upload template yet, please kindly click
          <a-button class="padding-remove" type="link" @click="handleDownload"
            >Download Template</a-button
          >
        </p>
        <a-upload
          accept=".xls, .xlsx"
          :showUploadList="true"
          :fileList="push"
          :beforeUpload="beforeUpload"
          :remove="handleRemove"
          v-decorator="['upload', { valuePropName: 'push' }]"
        >
          <a-button icon="upload">Select Document</a-button>
        </a-upload>
        <a-divider v-if="getScreen"></a-divider>
      </div>
      <a-button
        v-if="getScreen"
        type="primary"
        block
        @click="handleNew"
        :loading="newLoading"
        >Add</a-button
      >
    </a-col>
    <a-col :xs="{ span: 24 }" v-if="getScreen">
      <a-collapse class="margin-top">
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">Lihat Detail</h4>
          <a-list
            itemLayout="vertical"
            :dataSource="dataList"
            :pagination="pagination"
          >
            <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <a href="#">{{ item.deskripsi }}</a>
                </a-row>
                <div slot="description">
                  <ul class="m-list-wrapper">
                    <li class="margin-remove">
                      {{
                        moment(item.tanggal_pemakaian).format(
                          getDefaultDateFormat
                        )
                      }}
                    </li>
                    <li v-if="item.debit !== ''">
                      <h4 class="margin-remove m-text-sub">Debit</h4>
                      <h3 class="margin-remove">
                        {{ formatRupiah(item.debit) }}
                      </h3>
                    </li>
                    <li v-else>
                      <h4 class="margin-remove m-text-sub">Kredit</h4>
                      <h3 class="margin-remove">
                        {{ formatRupiah(item.kredit) }}
                      </h3>
                    </li>
                  </ul>
                </div>
              </a-list-item-meta>
              <a-button-group v-if="getScreen && item.kredit !== ''">
                <a-button type="primary" @click="handleEdit(item)">
                  <a-icon type="edit" />&nbsp;Change
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)">
                  <a-icon type="close" />&nbsp; Delete
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <div class="m-price-total" v-if="pageLoading === false">
        <div class="m-display-flex space-between align-middle">
          <h4>Total Kredit</h4>
          <h3>{{ formatRupiah(kredit) }}</h3>
        </div>
      </div>
      <a-checkbox :disabled="dataList.length < 1" @change="handleCheckData"
        >Is Data Completed?</a-checkbox
      >
    </a-col>

    <a-modal
      title="Confirmation"
      :visible="confirm"
      @ok="handleOk(type)"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading"
          @click="handleOk(type)"
          >OK</a-button
        >
      </template>
      <p>Data existing will be replaced, are you sure?</p>
    </a-modal>
    <Modal
      :dataParent="modal.data"
      :reportingList="dataList"
      :sppdList="sppdDetail"
      :modalEdit="modal.modalEdit"
      :confirmLoading="modal.confirmLoading"
    />
  </a-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Modal from "../Modal.vue";
import _ from "lodash";

export default {
  name: "pemakaian",
  components: {
    Modal,
  },
  mixins: [CurrencyFormat],
  props: {
    data: {},
    informasi: {},
    mode: {},
    url: "",
    id_klaim: "",
    dataList: {},
    debit: 0,
    kredit: 0,
    mata_uang: "",
    type: "",
  },
  data() {
    return {
      push: [],
      confirm: false,
      confirmLoading: false,
      newLoading: false,
      pageLoading: true,
      sppddtlLoading: false,
      sppdDetail: [],
      selectedSppd: Array,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      initialEdit: {},
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          id_sppd_dtl: "",
          type: "",
        },
      },
      EnCommission: true,
      Viwithout_note: true,
      doctransfiles: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDetailSppd",
    ]),
    initialList() {
      if (this.dataList.length > 0) {
        let kredit = 0;
        let data = this.dataList;
        if (this.dataList.length > 1 || this.dataList !== undefined) {
          data.forEach((item) => {
            kredit = parseInt(kredit) + parseInt(item.kredit);
          });
        }
        return { kredit: kredit };
      } else {
        return { kredit: 0 };
      }
    },
  },
  created() {
    this.fetchPemakaian();
    this.fetchSppd();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";

      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    handleRemove() {
      this.push = [];
    },
    done() {
      this.pageLoading = false;
    },
    async fetchSppd() {
      this.sppddtlLoading = true
      Event.$emit("fdisabledonLoadSPPDDtl", true);
      await axios({
        method: "get",
        url: process.env.VUE_APP_SERVICEURL + "klaim_cc_pd/sppd_detil",
        params: {
          id_sppd: this.informasi.id_sppd,
          id_klaim_draft: this.id_klaim,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((res) => {
        Event.$emit("fdisabledonLoadSPPDDtl", false);
        this.sppddtlLoading = false
        this.sppdDetail = res.data.list_nama_item;
      });
      // await axios({
      //   method: "get",
      //   url: this.$serviceUrl + "klaim_cc_pd/sppd_detil",
      //   params: {
      //     id_sppd: this.informasi.id_sppd,
      //     id_klaim_draft: this.id_klaim,
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // })
      //   .then((response) => {
      //     console.log(response.data.list_nama_item);
      //     this.sppdDetail = response.data.list_nama_item;
      //   })
      //   .catch((err) => {
      //     alert(err);
      //     // this.displayMessage("error-getdetil");
      //   });
    },
    fetchPemakaian() {
      this.pageLoading = true;
      Event.$emit("fetchPemakaian", true);
    },
    handleRemoveDetail(e) {
      Event.$emit("removeDetail", e);
    },
    handleOk(e) {
      Event.$emit("handleLoading", true);
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;

      let addData = new FormData();

      addData.append("tlc", this.getAuth.username);
      addData.append("id_klaim", this.id_klaim);
      addData.append("no_sppd", this.informasi.no_sppd);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getDefaultDateFormat)
      );
      this.push.forEach((file) => {
        addData.append("file_upload", file);
      });

      this.postUpload(addData);
    },
    handleCancel(e) {
      this.confirm = false;
      this.modal.modalEdit = false;
      Event.$emit("handleLoading", false);
    },
    handleSppd(e) {
      this.selectedSppd = this.sppdDetail.filter(
        (obj) => obj.id_sppd_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      let selectedumDtl = _.filter(this.sppdDetail, { id_sppd_dtl: e });
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "1",
              without_note: "1",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "0",
              without_note: "1",
          });
        });
      }
    },
    handleNew() {
      console.log('test');
      
      Event.$emit("handleLoading", true);
      if (this.push.length > 0 && this.dataList.length > 0) {
        this.confirm = true;
      } else if (this.push.length > 0) {
        let addData = new FormData();

        addData.append("tlc", this.getAuth.username);
        addData.append("id_klaim", this.id_klaim);
        addData.append("no_sppd", this.informasi.no_sppd);
        addData.append(
          "tanggal_pelaporan",
          this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
        );
        addData.append("iscommision", "0");
        addData.append("without_note", "1");

        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });

        addData.append("id_user_cc", this.informasi.id_user_cc);

        this.newLoading = true;
        this.pageLoading = true;

        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("form-warning");
            return;
          }

          if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
            Event.$emit("handleLoading", false);
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }

          this.handleSppd(values.id_sppd_dtl);
          if (values.kredit > this.selectedSppd[0].saldo_anggaran) {
            Event.$emit("handleLoading", false);
            this.displayMessage("over-kredit");
            return;
          }

          let addData = new FormData();
          addData.append("tlc", this.getAuth.username);
          addData.append("no_sppd", this.informasi.no_sppd);
          addData.append("id_klaim", this.id_klaim);
          addData.append("tanggal_pelaporan", this.informasi.tanggal_pelaporan.format(
            this.getStandartFormatDate
          ));
          addData.append("sppd_dtl", values.id_sppd_dtl);
          addData.append("tanggal_pemakaian", values.tanggal_pemakaian.format(
            this.getStandartFormatDate
          ));
          addData.append("deskripsi", values.detail_name);
          addData.append("kredit", values.kredit);
          addData.append("iscommision", values.iscommision);
          //addData.append("iscommision", values.without_note);
          addData.append("without_note", "1");
          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }
          addData.append("id_user_cc", this.informasi.id_user_cc);

          let url = this.type == 'revised' ? 'revisi_detil_pemakaian' : 'detil_pemakaian'
          this.newLoading = true;

          axios({
            method: "post",
            url: this.$serviceUrl + `klaim_cc_pd/${url}`,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              // "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.fetchSppd();
              this.fetchPemakaian();
              this.displayMessage("success-add");
              this.newLoading = false;
              this.pageLoading = false;
              this.form.resetFields();
              this.EnCommission=true;
              this.Viwithout_note=true;
              if (this.mode === "Create") {
                Event.$emit("disableInformasi", true);
              }
            })
            .catch((err) => {
              Event.$emit("handleLoading", false);
              console.log("error : " + err);
            });
        });
      }
    },
    postUpload(data) {
      let url =
        this.type === "revised"
          ? "klaim_cc_pd/revisi_upload_detil_pemakaian"
          : "klaim_cc_pd/upload_detil_pemakaian";
      axios({
        method: "post",
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-add");
            this.fetchPemakaian();
            this.newLoading = false;
            this.confirmLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            Event.$emit("disableInformasi", true);
          } else {
            this.displayMessage("success-edit");
            this.fetchPemakaian();
            this.newLoading = false;
            this.confirmLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            Event.$emit("disableInformasi", true);
          }
          this.push = [];
          Event.$emit("handleLoading", false);
        })
        .catch((err) => {
          this.displayMessage("error-upload");
          this.newLoading = false;
          this.pageLoading = false;
          this.confirm = false;
          this.confirmLoading = false;
          Event.$emit("disableInformasi", true);
          Event.$emit("handleLoading", false);
        });
    },
    handleCheckData(e) {
      Event.$emit("draftStatus", e.target.checked);
    },
    async handleFetchEdit(item) {
      const url =
        this.type == "draft"
          ? "klaim_cc_pd/detil_pemakaian_update"
          : "klaim_cc_pd/revisi_detil_pemakaian_update";
      return await axios({
        method: "get",
        url: this.$serviceUrl + url,
        params: {
          id_dtl_klaim: item.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleEdit(item) {
      this.sppddtlLoading = true
      this.handleFetchEdit(item).then((result) => {
        this.sppdDetail = result.data.list_dtl_sppd;
        this.modal.data = {
          tanggal_pemakaian: result.data.tgl,
          deskripsi: result.data.detail,
          kredit: result.data.kredit,
          id: result.data.id_dtl,
          id_sppd_dtl: result.data.selected_sppd_dtl,
          type: this.type,
        };
        this.modal.modalEdit = true;
        this.sppddtlLoading = false
      });

      // this.modal.data = {
      //   tanggal_pemakaian: item.tanggal_pemakaian,
      //   deskripsi: item.deskripsi,
      //   kredit: item.kredit,
      //   id: item.id,
      //   id_sppd_dtl: item.id_sppd_dtl_fk,
      //   type: this.type,
      // };
      // this.modal.modalEdit = true;
      // this.modal.type = this.type;
    },
    handleDownload() {
      axios({
        method: "get",
        url:
          this.$serviceUrl +
          "/main/download_template_klaim_biaya?X-API-KEY=xxx",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      //console.log(val)
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.form.setFieldsValue({
              without_note: "0",
          });
        });
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
  mounted() {
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("fetchSppd", this.fetchSppd);
  },
  beforeDestroy() {
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("fetchSppd", this.fetchSppd);
  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      gap: @padding / 2;
    }
  }
  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      float: unset !important;
      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
        float: unset !important;
      }
      &-selected-value {
        flex: 1;
        float: unset !important;
      }
    }
  }
  .ant-select-selection-selected-value {
    width: 100% !important;
  }
}
</style>
